export default [
    {title: 'Animals'},
    {title: 'Effects'},
    {title: 'Loops'},
    {title: 'Notes'},
    {title: 'Percussion'},
    {title: 'Space'},
    {title: 'Sports'},
    {title: 'Voice'},
    {title: 'Wacky'}
];
